import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '../../visual-feature.js';
import {Dialogs} from '../dialogs.js';

import QuickStartGuideService from './quick-start-guide-service.js';
import {quickStartGuideDialogConfig} from './quick-start-guide.factory.js';

import SCHEMA from './quick-start-guide.schema.yaml';
import PALETTE_SCHEMA from './quick-start-guide.palette-schema.yaml';

class QuickStartGuideFeature extends AbstractVisualFeature {
    get name() {
        return 'QuickStartGuide';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return mergeTo(quickStartGuideDialogConfig(PALETTE), {
            HomePage: {
                layoutParts: {
                    QuickStartGuideBanner: {
                        show: !!this.config.showBanner,
                    },
                },
            },
            QuickStartGuideBanner: {
                completeOnboardingAfterOpen: !!this.config.completeOnboardingAfterOpen,
            },
        });
    }

    updateMojitoConfig(mojitoConfig) {
        mojitoConfig.services.quickStartGuideService = {service: new QuickStartGuideService(this.config)};

        super.updateMojitoConfig(mojitoConfig);
    }
}

export const QuickStartGuide = new QuickStartGuideFeature(Dialogs);
